import { connect } from 'react-redux';
import { launchPageActions } from '@codametrix/ui-common';
import { CaseChooser } from './case-chooser';

const { selectCase } = launchPageActions;

export const mapStateToCaseChooserProps = (
  state: any
): Accelerate.CaseChooserData => {
  return {
    cases: state.codeBench.cases,
    launchParams: state.launch.launchParams
  };
};

export const mapDispatchToCaseChooserProps = (
  dispatch: any
): Accelerate.CaseChooserMethods => {
  return {
    chooseCase: (caseRun: CMxAPI.CaseRun) => {
      dispatch(selectCase(caseRun));
    }
  };
};
